import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import HotGamesSection from './components/HotGamesSection';
import PromotionsSection from './components/PromotionsSection';
import NewsSection from './components/NewsSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import { siteConfig } from '@/mocks/siteConfig';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteConfig.url}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
    email: siteConfig.email,
    telephone: siteConfig.phone,
    address: {
      '@type': 'PostalAddress',
      streetAddress: siteConfig.address,
      addressCountry: 'CN',
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${siteConfig.name} - ${siteConfig.tagline}`,
    description: siteConfig.description,
    url: siteConfig.url,
    isPartOf: {
      '@type': 'WebSite',
      name: siteConfig.name,
      url: siteConfig.url,
    },
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />

      <header>
        <Navbar />
      </header>

      <main>
        <HeroSection />
        <CategorySection />
        <HotGamesSection />
        <PromotionsSection />
        <NewsSection />
        <WhyChooseUsSection />
        <section className="w-full py-14 bg-background-100">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">开启您的娱乐新旅程</h2>
            <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-lg mx-auto">
              立即注册九游娱乐，领取专属新人礼包，畅享海量精品游戏
            </p>
            <button className="px-10 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-base whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all hover:scale-105">
              立即注册，领取188元新人礼
            </button>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}